import React from 'react';
import { Pod, PodMember } from '@/types/pods';
import { Card, CardContent } from '@/components/ui/card';
interface ProfileCardProps {
	profile: PodMember;
	pod: Pod;
}

export function ProfileCard({ profile, pod }: ProfileCardProps) {
	return (
		<Card>
			<CardContent className='pt-6'>
				<div className='flex items-center gap-4'>
					<div className='space-y-2'>
						<h3 className='font-semibold'>{profile.email}</h3>
						<div className='flex items-center gap-2'>
							<p className='text-sm text-gray-500'>
								@{profile.socialUsername}
							</p>
							<span className='px-2 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1 bg-purple-600 text-white'>
								<span className='text-base'>
									{pod.platform.toLowerCase() === 'twitter' ||
									pod.platform.toLowerCase() === 'twitterx'
										? '𝕏'
										: pod.platform.toLowerCase() ===
											  'linkedin'
											? 'in'
											: 'f'}
								</span>{' '}
								{pod.platform}
							</span>
						</div>
					</div>
				</div>
			</CardContent>
		</Card>
	);
}
